module.exports = __webpack_public_path__ + "img/Weapon_266.96472c88.png";